export * from './outlookSpacesApi';

import * as localService from './localService';
export { localService };

export { default as OutlookSpacesOwsClient } from './OutlookSpacesOwsClient';
export { default as getDefaultOutlookSpacesService } from './getDefaultOutlookSpacesService';
